module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "user-details"
  }, [(_vm.confirm.enabled) ? _c('confirm', {
    on: {
      "cancel": function($event) {
        _vm.confirm.enabled = false
      },
      "confirm": _vm.onConfirm
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirm.msg)
    },
    slot: "body"
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "bg-blue-grey"
  }, [_vm._v("SyncActions")]), _vm._v(" "), (_vm.user.actions.length) ? _c('div', [_c('table', {
    staticClass: "split-50 table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.user.actions), function(action) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(action.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(action.reason))])])
  }))])]) : _c('div', {
    staticClass: "bordered-row"
  }, [_c('p', [_vm._v("No pending sync actions")])]), _vm._v(" "), _vm._v(" "), _c('h4', {
    staticClass: "bg-blue-grey"
  }, [_vm._v("User Data")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h4', {
    staticClass: "bg-light-green"
  }, [_vm._v("Schoox User")]), _vm._v(" "), _c('table', {
    staticClass: "user-details-table table table-striped table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.suName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Id:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.su.id))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.su.email))])])])]), _vm._v(" "), _c('h4', {
    staticClass: "bg-light-green"
  }, [_vm._v("Locations")]), _vm._v(" "), _c('table', {
    staticClass: "split-50 table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.su.schooxLocations), function(loc) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(loc.name))]), _vm._v(" "), _c('td', {
      domProps: {
        "innerHTML": _vm._s(_vm.getJobs(loc.jobs))
      }
    })])
  }))]), _vm._v(" "), _c('h4', {
    staticClass: "bg-light-green"
  }, [_vm._v("Academy Members")]), _vm._v(" "), _c('table', {
    staticClass: "split-50 table table-striped table-bordered"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.su.acadMembers), function(member) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(member.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(member.hourlyWorker))])])
  }))]), _vm._v(" "), _c('h4', {
    staticClass: "bg-light-green"
  }, [_vm._v("SSO Users")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.su.ssoUsers), function(sso) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(sso.userId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sso.ssoId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sso.externalId))]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "timestamp",
        rawName: "v-timestamp",
        value: (sso.timeAdded),
        expression: "sso.timeAdded"
      }]
    })]), _vm._v(" "), _c('td', [_c('span', {
      directives: [{
        name: "timestamp",
        rawName: "v-timestamp",
        value: (sso.modifiedAt),
        expression: "sso.modifiedAt"
      }]
    })])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._l((_vm.user.hsUsers), function(hsu, i) {
    return [_c('h4', {
      staticClass: "bg-blue-hs"
    }, [_c('button', {
      staticClass: "pull-right",
      on: {
        "click": function($event) {
          _vm.confirmDelink(i)
        }
      }
    }, [_vm._v("Delink User")]), _vm._v("HotSchedules User " + _vm._s(_vm.inc1(i)))]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped table-bordered"
    }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Name:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getUserName(hsu)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ids:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.displayList(hsu.ids)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.email))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HRID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.hrid))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Asc:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.asc))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Active")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(hsu.active))])])])]), _vm._v(" "), _c('h4', {
      staticClass: "bg-blue-hs"
    }, [_vm._v("Locations")]), _vm._v(" "), (hsu.locations.length) ? _c('table', {
      staticClass: "table table-striped table-bordered"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', _vm._l((hsu.locations), function(loc, li) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(loc.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.acadId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.hierarchyid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(loc.extCompRef))]), _vm._v(" "), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getJobs(loc.jobs))
        }
      })])
    }))]) : _c('div', {
      staticClass: "bordered-row"
    }, [_c('p', [_vm._v("No Locations Listed")])]), _vm._v(" "), _vm._v(" "), _c('h4', {
      staticClass: "bg-blue-hs"
    }, [_vm._v("Employee Set")]), _vm._v(" "), (hsu.employeeSet.set.length) ? _c('table', {
      staticClass: "table table-striped table-bordered table-compact"
    }, [_vm._m(5, true), _vm._v(" "), _c('tbody', _vm._l((hsu.employeeSet.set), function(row) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.getUserName(row.employee)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.hrid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.location.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.employee.active))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.location.hierarchyid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.location.extCompRef))]), _vm._v(" "), _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm.getJobs(row.employee.jobs))
        }
      })])
    }))]) : _c('div', {
      staticClass: "bordered-row"
    }, [_c('p', [_vm._v("No Employee Set Data")])]), _vm._v(" ")]
  })], true)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Sync Action Description (for next sync)")]), _vm._v(" "), _c('th', [_vm._v("Sync Action Reason")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("jobs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("id")]), _vm._v(" "), _c('th', [_vm._v("Hourly")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("User Id")]), _vm._v(" "), _c('th', [_vm._v("SSO Id")]), _vm._v(" "), _c('th', [_vm._v("External Id")]), _vm._v(" "), _c('th', [_vm._v("Added")]), _vm._v(" "), _c('th', [_vm._v("Last Modified")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Academy Id")]), _vm._v(" "), _c('th', [_vm._v("Hierarchy Id")]), _vm._v(" "), _c('th', [_vm._v("extCompRef")]), _vm._v(" "), _c('th', [_vm._v("jobs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("HRID")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Active")]), _vm._v(" "), _c('th', [_vm._v("Hierarchy Id")]), _vm._v(" "), _c('th', [_vm._v("extCompRef")]), _vm._v(" "), _c('th', [_vm._v("Jobs")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2eb99e16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserDetails.vue
// module id = 409
// module chunks = 2